import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { CategorySection } from '../components/home/CategorySection';
import { LuxuryShowcaseSection } from '../components/home/LuxuryShowcaseSection';
import { FeaturedProductsSection } from '../components/home/FeaturedProductsSection';
import { FeaturesSection } from '../components/home/FeaturesSection';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { CatalogCTASection, ContactCTASection } from '../components/home/CTASections';

export const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <CategorySection />
      <LuxuryShowcaseSection />
      <FeaturedProductsSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CatalogCTASection />
      <ContactCTASection />
    </div>
  );
};
